import * as React from "react"
import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Form from "@bappweb/form"
import TextField from "@bappweb/textfield"
import Button from "@bappweb/button"
import { required } from "@bappweb/utils"
import { Sizes, useDeviceSize } from "@bappweb/provider"
import Page from "@components/globalmodules/page"
import BigLogoAkbank from "@components/globalmodules/logo/index-bigLogo"
import "./style.scss"
import { CaptchaVerifyService } from "@config/axios/captchaVerifyService"
import { useHistory } from "react-router-dom"
import { SendSMSOTPService } from "@config/axios/sendSMSOTPService"
import { CaptchaCallService } from "@config/axios/captchaCallService"
import { UserInfoService } from "@config/axios/userInfoService"
import { AuthenticateService } from "@config/axios/authenticate"
import { CompositeChangePassword } from "@config/axios/compositeChangePassword"
import { email as checkEmail } from "@bappweb/utils"
import { numeric, maxValue } from "@bappweb/utils"
let retRegistryPhone = "";

let responseSMSData: { retCode: number, retMsg: string, refId: string } = {
  retCode: 0,
  retMsg: "",
  refId: ""
}


let captchaVerifyRespData: { result: string, resultCode: number, resultMessage: string } = {
  result: "",
  resultCode: 0,
  resultMessage: ""
}


let userInfoRespData: { retPhone: string, retCode: string, retMsg: string } = {
  retPhone: "",
  retCode: "",
  retMsg: ""
}
let responseAuthenticate: { ldapReturnCode: string, ldapReturnMessage: string } = {
  ldapReturnCode: "",
  ldapReturnMessage: ""
}



const SftpChangePassword = () => {
  const { t } = useTranslation()
  const size = useDeviceSize()
  const history = useHistory()


  const [base64Image, setbase64Image] = React.useState("");
  const [changeServiceRetCodes, setRetCode] = useState("");
  const [changeServiceRetMsg, setRetMsg] = useState("");
  const [captchaResp, setCaptchaResp] = useState({ id: "" });


  useEffect(() => {
    const fetchData = async () => {
      const data = await CaptchaCallService();
      setCaptchaResp(data);
      ConvertBase64ToImage(data);
    }

    fetchData();
  }, []);

  const handleSubmit = React.useCallback(async (e, data) => {
    if (data.newpassword === data.newpasswordagain) {
      //////******************** */
      //  responseAuthenticate = await AuthenticateService({ username: data.userName, currentPsw: data.password });
      responseSMSData = await CompositeChangePassword({ id: captchaResp.id, entry: data.securityCode, userId: data.userName, mail: data.mail, phone: data.phone, password: data.password });
      debugger;
      if (responseSMSData.retCode === 0) {
        const passData = { refId: responseSMSData.refId, userName: data.userName, mail: data.mail, phone: data.phone, currentPsw: data.password, newPsw: data.newpassword, newPswAgain: data.newpasswordagain };
        history.push('/sftp-changePassword-smsOtp', { passData });

      }
      else {

        setRetCode(responseSMSData.retCode.toString())
        setRetMsg(responseSMSData.retMsg);

      }

    } else {

      setRetMsg(t("New passwords are not the same"));
    }


  }, [history, captchaResp, t])

  const handleError = React.useCallback((e, errors) => {
    console.info(JSON.stringify(errors, void 0, 2))
  }, [])



  const handleReloadCaptchaClick = React.useCallback(async () => {

    const data = await CaptchaCallService();
    setCaptchaResp(data);
    ConvertBase64ToImage(data);

  }, [])


  function ConvertBase64ToImage(respData) {
    setbase64Image(respData.base64Contents);
  }


  const main = useMemo(() => {
    return (

      <Block className="bapp-page-login-main">
        <Block className="bapp-page-login-main-wrapper">
          <Element type="h1" style={{ fontSize: "24px", fontFamily: "Campton", textAlign: "center", fontWeight: "550" }}>{t("Change Password")}</Element>
          <Element className="sftp-header" style={{ fontSize: "14px", fontFamily: "Campton", textAlign: "center", fontWeight: "475", lineHeight: "20px" }} >{t("You can change your password here.")}</Element>

          <Form onSubmit={handleSubmit} onError={handleError} grid={false}>
            <TextField
              label={t("KULLANICI ADI")}
              placeholder={t("Kullanıcı Adın")}
              type="text"
              name="userName"
              validations={[
                required(t("validation.required"))

              ]}
            />
            <TextField
              label={t("E-POSTA")}
              placeholder={t("E-Postan")}
              type="text"
              name="mail"
              validations={[
                required(t("validation.required")),
                checkEmail(t("validation.checkEmail"))

              ]}
            />
            <TextField
              label={t("TELEFON")}
              placeholder={t("Telefon Numaran")}
              type="text"
              name="phone"
              maxLength={15}
              validations={[
                required(t("validation.required")),
                numeric(t("validation.numeric"))
              ]}
            />

            <TextField
              label={t("ŞİFRE")}
              placeholder={t("Mevcut Şifren")}
              type="password"
              name="password"
              validations={[required(t("validation.required"))]}
            />


            <div className="bapp-form-input">
              <div className="bapp-input-container" style={{ zIndex:2 }}>
                <label className="bapp-input-label" htmlFor="password">
                  {t("YENİ ŞİFRE")}
                  <span className="tooltip-container">
                    <img src="../img/svg/drawer-icons-info.svg"
                      style={{ width: 16, height: 16, cursor: "help" }}></img>
                    <span className="tooltip-text">
                      <ul>
                        <li>- Şifrede en az 1 harf olmalıdır.</li>
                        <li>- Şifreniz, son 5 şifrenizden farklı olmalıdır.</li>                       
                        <li>- Şifrede en az 8 karakter olmalıdır.</li>
                        <li>- Şifre en az 3 karakter türüne sahip olmalıdır.</li>
                        <li>- Şifrede en az 1 sayı olmalıdır.</li>
                         <li>- Şifrede en az 1 küçük harf olmalıdır.</li>
                        <li>- Şifrede en az 1 büyük harf olmalıdır.</li>
                      </ul>                     
                     
                    </span>
                  </span>
                </label>
              </div>
            </div>


            <TextField
              label=""
              className="newPswPadding"
              placeholder={t("Yeni Şifren")}
              type="password"
              name="newpassword"
              validations={[required(t("validation.required"))]}
            />

            <TextField
              label={t("YENİ ŞİFRE TEKRAR")}
              placeholder={t("Yeni Şifren")}
              type="password"
              name="newpasswordagain"
              validations={[required(t("validation.required"))]}
            />
            <div style={{ display: "flex" }}>
              <TextField
                label={t("GÜVENLİK KODU")}
                placeholder={t("Güvenlik Kodun")}
                type="text"
                name="securityCode"
                validations={[required(t("validation.required"))]}
              />
              <span style={{ width: "30%", paddingTop: "13%" }}>
                <img src={"data:image/png;base64," + base64Image} width={"100%"} alt="Logo4" />
              </span>
              <span style={{ width: "10%", paddingTop: "13%" }}>
                <img src="../img/reload_icon.png" alt="logo" height={"40%"} onClick={handleReloadCaptchaClick} />
              </span>
            </div>
            <Button text={t("Change Password")} type="submit" fullWidth />
          </Form>
          {
            changeServiceRetCodes !== '0' ? <p style={{ color: "#c81c27" }}><b>{changeServiceRetMsg}</b></p> : ""
          }

        </Block>
      </Block>
    )
  }, [handleError, handleSubmit, t, base64Image, handleReloadCaptchaClick, changeServiceRetCodes, changeServiceRetMsg])

  return (
    <Page className="bapp-page-login" container={false} footer={false}>
      {size !== Sizes.xs ? (
        <>
          <Block className="" />
          <Block className="bapp-page-login-desktop-wrapper bapp-container">
            <Block>
              <BigLogoAkbank />

              <Image path={"/img/svg/unlock-woman.svg"} fallbackText={t("Oriented Woman")} />
              <Element className="sftp-header" style={{ fontSize: "34px", color: "black" }} type="h2" >{t("Your files are safe with the file sharing center")}</Element>
              <Element style={{ fontSize: "23px", color: "black" }}>{t("Akbank güvenli dosya transferi ile FTP dosyalarını güvenli bir şekilde aktarabilirsiniz.")} </Element>
            </Block>
            {main}
          </Block>
        </>
      ) : (
        main
      )}
    </Page>

  )
}

export default SftpChangePassword
